module.exports = __webpack_public_path__ + "img/back.f9c2a155.png";